module.exports = __webpack_public_path__ + "img/call-bg.94f4f509.png";